document.addEventListener('click', function(event) {
  const control = event.target.closest('button[data-scroll-target]');
  if (!control) return;
  const target = document.getElementById(control.dataset.scrollTarget);
  if (!target) return;
  const menu = control.closest('details');
  if (menu) menu.open = false;
  target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  if (control.dataset.scrollTarget === 'MainContent') target.focus({ preventScroll: true });
});